import React from "react";
import { useLocation, Route } from "react-router-dom";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
import { ROUTE_PANEL } from "../routes/routesConstants";
import { isUserInRole } from "../../commonFunctions/commonFunctions";
import { useSelector } from "react-redux";
import { selectUserRoles, selectUserSuperAdmin } from "../../redux/authentication/selectors";

function PrivateRoute(props) {
  const location = useLocation();
  const { allowedRoles = ["*"], redirectRoute = ROUTE_PANEL, strictRoles = false } = props;
  const userRoles = useSelector(selectUserRoles);
  const userSuperAdmin = useSelector(selectUserSuperAdmin);
  const isAllowed = allowedRoles.some((x) => x === "*" || isUserInRole(x, userRoles, userSuperAdmin, strictRoles));

  if (isAllowed) {
    return <Route path={props.path} component={props.component}></Route>;
  } else {
    return <Redirect to={redirectRoute} state={{ from: location.pathname, search: location.search }} />;
  }
}

export { PrivateRoute };